"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Phone = _interopRequireDefault(require("../Phone"));
const PhoneWithHint = _ref => {
  let {
    phone,
    phoneHint,
    classes
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Phone.default, {
    number: phone,
    classes: {
      phoneNum: classes.phoneNum
    }
  }), phoneHint && /*#__PURE__*/_react.default.createElement("p", {
    className: classes.phoneHint
  }, phoneHint));
};
var _default = PhoneWithHint;
exports.default = _default;